import options from './thing-name.component';

export default {
    selector: 'dtThingDetailsName',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-name/index.js